import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem("os_token", data.access_token);
            localStorage.setItem("os_email", data.email);
            toast.success("Bun venit!");
            navigate("/admin/dashboard");
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#0d3d2e] grain-overlay flex items-center justify-center px-6">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <img
                        src="/icon-192.png"
                        alt="OPTIM SAFE"
                        className="h-20 w-auto object-contain mx-auto mb-5 rounded-full"
                    />
                    <h1 className="font-display text-3xl text-[#fcfbf8] mb-2">Admin OPTIM SAFE</h1>
                    <p className="text-[#fcfbf8]/65 text-sm">Conectare panou administrare</p>
                </div>
                <form onSubmit={submit} data-testid="login-form" className="bg-[#fcfbf8] rounded-2xl p-8 space-y-5">
                    <div>
                        <label className="block text-xs uppercase tracking-[0.16em] text-[#0d3d2e]/70 mb-2">Email</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            data-testid="login-email"
                            className="w-full border border-[#0d3d2e]/20 rounded-md px-4 py-3 text-[#0d3d2e] focus:outline-none focus:border-[#0d3d2e]"
                            placeholder="admin@optimsafe.ro"
                        />
                    </div>
                    <div>
                        <label className="block text-xs uppercase tracking-[0.16em] text-[#0d3d2e]/70 mb-2">Parolă</label>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            data-testid="login-password"
                            className="w-full border border-[#0d3d2e]/20 rounded-md px-4 py-3 text-[#0d3d2e] focus:outline-none focus:border-[#0d3d2e]"
                            placeholder="••••••••"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={submitting}
                        data-testid="login-submit"
                        className="w-full rounded-full bg-[#0d3d2e] text-[#fcfbf8] py-3 font-medium hover:bg-[#0d3d2e]/90 transition-colors disabled:opacity-60"
                    >
                        {submitting ? "Se conectează..." : "Conectează-te"}
                    </button>
                </form>
                <div className="text-center mt-6">
                    <a href="/" className="text-sm text-[#fcfbf8]/60 hover:text-[#fcfbf8] transition-colors">← Înapoi la site</a>
                </div>
            </div>
        </div>
    );
}
